const getApiUrl = ( windowLocation, apiHostname, devApiPort, devUIPort ) => {

    const envs = [ 'dev.', 'ci.', 'qa.', 'pprd.' ];
    const env = windowLocation.hostname.split( '.' ).find( chunk => {
        return envs.indexOf( chunk + '.' ) >= 0;
    } );

    const urlParts = [
        windowLocation.protocol,
        '//',
        env ? env + '.' : '',
        windowLocation.port ? windowLocation.hostname : apiHostname,
        windowLocation.port ? ':' + windowLocation.port.replace( devUIPort, devApiPort ) : ''
    ];

    return urlParts.join( '' );

};

const baseURL = getApiUrl( window.location, 'api.biw.cloud/v1/proaccounts-api', 3000, 5000 );

const DEFAULT_OPTIONS = {
    method: 'GET',
    credentials: 'same-origin',
    noparse: undefined,
    baseURL: baseURL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    }
};

// JSESSIONID
let sessionId;

const fetchFunction = function ( url, options = DEFAULT_OPTIONS ) {

    const clientId = `${window.location.protocol}//${window.location.hostname}`;
    const clientIdHeader = { 'client-id': clientId };

    const fetchOptions = Object.assign( {}, DEFAULT_OPTIONS, options );

    const fetchHeaders = Object.assign( {}, fetchOptions.headers, DEFAULT_OPTIONS.headers, Object.assign( {}, options.headers, clientIdHeader ) );
    fetchOptions.headers = fetchHeaders;

    if ( fetchOptions.bodyIsFormData ) {
        delete fetchOptions.headers[ 'Content-Type' ];
    }

    if ( sessionId ) {
        fetchOptions.headers[ 'x-session-id' ] = sessionId;
    } else {
        delete fetchOptions.headers[ 'x-session-id' ];
    }

    // Only GET and POST requests return data
    const responseBodyExpected = /get|post/.test( fetchOptions.method.toLowerCase() );
    if ( !responseBodyExpected ) {
        fetchOptions.headers[ 'Accept' ] = '*/*';
    }

    // Check whether to parse the response for JSON
    const parseResponse = !fetchOptions.noparse;
    delete fetchOptions.noparse;

    // If submitting non-url form data and we're submitting JSON, then stringify it
    if ( fetchOptions.body && fetchOptions.headers[ 'Content-Type' ] === 'application/json' && typeof ( fetchOptions.body ) === 'object' ) {
        fetchOptions.body = JSON.stringify( fetchOptions.body );
    }

    url = fetchOptions.baseURL ? `${fetchOptions.baseURL}${url}` : url;

    return fetch( url, fetchOptions )

        // parse the response
        .then( response => {
            const contentType = response.headers.get( 'Content-Type' );
            if ( typeof contentType === 'string' && contentType.indexOf( 'application/json' ) !== -1 && parseResponse ) {
                return response.json()
                    .then( result => ( {
                        result,
                        status: response.status
                    } ) )
                    .catch( jsonParseError => {
                        throw new Error( `Expected JSON from remote server, but could not parse the response: "${ jsonParseError.message }".` );
                    } );
            }
            return {
                result: response,
                status: response.status
            };
        } )

        // Check the status
        .then( ( { result, status } ) => {
            // if there is a session and the status is 401 reload the page.
            if ( sessionId !== undefined && sessionId !== null && status === 401 ) {
                //clear session storage.
                sessionStorage.setItem( 'userState', null );
                sessionStorage.setItem( 'bundleState', null );

                // flag that the session timed out for use after page refreshes
                sessionStorage.setItem( 'sessionTimedOut', 'true' );

                //reload the page.
                window.location.reload();
            }

            if ( status >= 200 && status < 300 ) {
                return result;
            }
            // Error situation
            if ( isError( result ) ) {
                throw result;
            }
            throw new Error( typeof result === 'string' ? result : JSON.stringify( result ) );
        } );
};

fetchFunction.setSessionId = ( id ) => {
    sessionId = id;
};

function isError( test ) {
    return ( typeof test.message === 'string' && typeof test.name === 'string' )
        || ( typeof test.errorCode === 'number' )
        || ( test.errorCode === null && typeof test.responseMessage === 'string' ) ;
}

fetchFunction.getApiUrl = getApiUrl;

export default fetchFunction;
